<template>
    <div>
        <PageHeader>
            {{ $t('activateTipbox') }}
        </PageHeader>

        <Card>
            <div class="d-flex flex-column flex-md-row">
                <section class="width-max-900 ">
                    <h2 class="mb-3">{{ $t('activateTipbox') }}</h2>
                    <p class=" mb-4">{{ $t('description') }}</p>
                    <p class=" mb-4">{{ $t('descriptionSecondLine') }}</p>
                    <div class="mt-4">
                        <FormTipboxSettings class="reset-mx-auto width-max-900" @next="onPolicyAccepted" />
                    </div>
                    <div class="width-max-900 mx-auto p-3 bg-light rounded d-flex gap-2">
                        <feather type="lock" size="16" class="flex-shrink-0 mt-1" />
                        <p class="m-0">{{ $t('note') }}</p>
                    </div>
                </section>

                <section class="d-none d-md-flex align-items-center justify-content-center w-100">
                    <div class="width-max-500 ">
                        <img src="@/assets/tipbox/hero-img.webp" :alt="$t('heroImgAlt')" class="img-fluid">
                    </div>
                </section>
            </div>
        </Card>
    </div>
</template>

<script>
    import usercomService from '@/services/usercomService';
    import FormTipboxSettings from '../../entry-page/parts/FormTipboxSettings.vue';

    export default {
        name: 'TipboxPolicies',
        components: {
            FormTipboxSettings,
        },
        props: {
            header: {
                type: String,
                default: '',
            },
        },

        methods: {
            onPolicyAccepted() {
                const data = this.$store.getters['tipbox/getTipboxSettings'];
                if (!data) {
                    return;
                }
                try {
                    usercomService.userengage('tipbox_activated');
                    window.Gleap.startBot('67bf232d13e4fb36934aa42a');
                } catch (error) {
                    console.error(error);
                }
            },
        },
    };
</script>

<style scoped>
    .reset-mx-auto {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
</style>

<i18n lang="json" locale="pl" scope="local">
{
    "description": "Zacznij przyjmować napiwki i pozwól odbiorcom podziękować Ci za to, co robisz.",
    "descriptionSecondLine": "Zanim uruchomimy Twojego tip.BOX-a, potrzebujemy kilku informacji. To krótka formalność — wymagają tego od nas przepisy podatkowe i przepisy o przeciwdziałaniu praniu pieniędzy. Dzięki nim możemy bezpiecznie i legalnie przekazywać Ci środki od Twoich odbiorców.",
    "note": "Twoje dane są bezpieczne. Przechowujemy je zgodnie z przepisami RODO i przetwarzamy tylko w zakresie niezbędnym do świadczenia usługi.",
    "heroImgAlt": ""
}
</i18n>

<i18n lang="json" locale="en" scope="local">
{
    "description": "Start accepting tips and let your supporters thank you for what you do.",
    "descriptionSecondLine": "Before we launch your tip.BOX, we need a few pieces of information. It’s a brief formality required by tax and anti–money laundering regulations. This ensures we can securely and legally transfer funds from your supporters to you.",
    "note": "Your data is secure. We store it in accordance with GDPR and process it only as necessary to provide the service.",
    "heroImgAlt": "Donation page for a book influencer featuring a profile photo, thank-you message in Polish about supporting literary content, social media links, preset donation amounts (5 zł, 10 zł, 15 zł), a custom amount field, personal information inputs, and a payment button powered by imoje with Visa and Mastercard logos."
}
</i18n>

